import { Component, OnInit, Input } from '@angular/core';
import { CurrentUserService } from '@core/services/currentUser.service';

// Bump this ID whenever you want a new banner to show (even to users who dismissed the previous one)
const BANNER_ID = 'v1';

@Component({
  selector: 'app-announcement-banner',
  templateUrl: './announcement-banner.component.html',
  styleUrls: ['./announcement-banner.component.scss'],
})
export class AnnouncementBannerComponent implements OnInit {
  visible = false;

  constructor(private currentUserService: CurrentUserService) {}

  get tenantId(): string {
    return this.currentUserService.tenantGlobalService ?? '';
  }

  ngOnInit(): void {
    const userId = this.currentUserService.currentUser?.id;
    if (!userId) return;
    const key = `banner_dismissed_${userId}_${BANNER_ID}`;
    this.visible = !localStorage.getItem(key);
  }

  dismiss(): void {
    const userId = this.currentUserService.currentUser?.id;
    if (userId) {
      localStorage.setItem(`banner_dismissed_${userId}_${BANNER_ID}`, '1');
    }
    this.visible = false;
  }
}
